import React from 'react';
import { motion } from 'framer-motion';
const fade = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.9,
      ease: [0.16, 1, 0.3, 1]
    }
  }
};
const legend = [{
  label: 'School',
  color: '#2E8AA0'
}, {
  label: 'Malls',
  color: '#7B5FC4'
}, {
  label: 'Sports',
  color: '#E08B3E'
}, {
  label: 'Grocery',
  color: '#4E7A3A'
}, {
  label: 'Hospital',
  color: '#D85A52'
}];
export function LocationSection() {
  return <section className="w-full bg-bg-light py-14 md:py-24 px-6 md:px-14 relative z-10" data-id="element-109">
      <motion.div initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-80px'
    }} variants={fade} className="max-w-7xl mx-auto" data-id="element-110">
        {/* Top: two columns — address (left) + legend (right) */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16 items-start mb-8 md:mb-12" data-id="element-111">
          {/* Location + address */}
          <div data-id="element-112">
            <h2 className="font-heading text-2xl md:text-4xl font-light tracking-tight text-primary" data-id="element-113">
              Location
            </h2>
            <div className="mt-3 md:mt-4 space-y-0.5 text-base md:text-lg font-light leading-relaxed text-text-muted" data-id="element-114">
              <p data-id="element-115">Phase 6 Blk 4 Lot 17, Campanilla St.</p>
              <p data-id="element-116">Corner Agoho St., Ayala Westgrove Heghts,</p>
              <p data-id="element-117">South Boulevard, Silang, 4118 Cavite</p>
            </div>
          </div>

          {/* Legend — compact */}
          <div className="md:pt-1" data-id="element-118">
            <h3 className="text-xs tracking-widest font-light text-text-muted uppercase mb-3 md:mb-4" data-id="element-119">
              Legend
            </h3>
            <ul className="flex flex-wrap gap-x-5 gap-y-2.5" data-id="element-120">
              {legend.map(item => <li key={item.label} className="flex items-center gap-2" data-id="element-121">
                  <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{
                backgroundColor: item.color
              }} data-id="element-122" />
                  <span className="tracking-wide text-text-muted font-light text-sm" data-id="element-123">
                    {item.label}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Location map — full width below, on the neutral base tone */}
        <div className="w-full bg-[#EFEAE1] flex items-center justify-center p-4 md:p-8" data-id="element-124">
          <img src="https://cdn.magicpatterns.com/uploads/tavxGPiJmwYRpBxB5US2y2/3.png" alt="Vicinity map showing 35 Campanilla's location in Ayala Westgrove Heights, with nearby schools, malls, and expressway exits" className="w-full h-auto max-h-[70vh] object-contain" data-id="element-125" />
        </div>
      </motion.div>
    </section>;
}